import { graphql } from "@server/gql";

export const addWishlistTagMutation = graphql(/* GraphQL */ `
  mutation addWishlistTag($payload: TagInputDtoInput!, $token: String!) {
    addWishlistTag(payload: $payload, token: $token) {
      isError
      data {
        id
        name
        shareLink
      }
      error {
        __typename
        ...problemDetails
        ...genericResponse
      }
    }
  }
`);
